export default __webpack_public_path__ + "static/media/VIC-CHANGEOFADDRESS3.5123879b.png";